<aslib-title Text="Transmissão / Arquivo IPM" SubText="Transmitir" Icon="fa fa-dollar"></aslib-title>

<form novalidate [formGroup]='formTransmitirPlanilha'>
  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Tipo de Receita:<span>*</span></label>
    <div class="controls col-md-3">
      <select [(ngModel)]="inputDadosModelView.TipoReceitaSelected"  formControlName="TipoReceita" class="form-control">
        <option  [ngValue]=undefined>Selecione</option>
        <option *ngFor="let tipoReceita of outputDadosModelView.ListaTipoReceita" [ngValue]="tipoReceita">{{tipoReceita.Descricao}}</option>
      </select>
    </div>
  </div>

  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Arquivo IPM:<span>*</span></label>
    <div class="controls col-md-6">
      <input class="form-control" type="file" #fileInput accept=".txt,.REM"  formControlName="ArquivoIpm"/>
    </div>

  </div>

  <div class="form-group row">
    <div class="controls col-md-9 offset-md-3">
      <button type="submit" class="btn btn-primary" (click)="TransmitirArquivoIpm(modalCredenciais)" [disabled]="!formTransmitirPlanilha.valid">
        <aslib-icon type="1" icon="fa fa-check"></aslib-icon>Confirmar </button>
    </div>
  </div>

</form>

<aslib-modal #modalMensagem></aslib-modal>
<aslib-modal #modalCredenciais></aslib-modal>

<ng-template #templateCredenciais>

  <div class="row">
    <div class="col-12">
      <label for="login">Login:</label>
      <input type="text" [(ngModel)]="credenciais.user" class="form-control" />
      <small id="login-alert" class="form-text text-muted" *ngIf="credenciais.user === ''" style="margin-bottom: 10px;">Campo vazio</small>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <label for="senha">Senha:</label>
      <input type="password" [(ngModel)]="credenciais.password" class="form-control" />
      <small id="senha-alert" class="form-text text-muted" *ngIf="credenciais.password === ''">Campo vazio</small>
    </div>
  </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/ipm/transmissao-arquivo-ipm/transmissao-arquivo-ipm.component.html